import SigliveServiceV1 from 'Service/sigliveServiceV1';

const getExportOperatorBreaks = async (queries) => {
  const { data } = await SigliveServiceV1({ method: 'GET', url: `attendance-report/breaks/export?${queries}`, responseType: 'blob' });

  return data;
};

export default getExportOperatorBreaks;
